import { App } from 'vue'
import Button from './Button.vue';
import Select from './Select.vue';

const install = function (app) {
  app.component('YuiButton', Button)
  app.component('YuiSelect', Select)
}

export default install
